
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headhunt-service/en",
      function () {
        return require("private-next-pages/headhunt-service/en.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headhunt-service/en"])
      });
    }
  